import { useContext } from 'react'

import { Form } from 'components/Form'
import { UserManagementFormContext } from '../../contexts/UserManagementFormContext'
import { CommonForm } from './CommonForm'
import { useUpdateEmployee } from './hooks/useUpdateEmployee'
import { EditSchema, editSchema, editSchemaDefault } from './schemas/edit'
import { UserEditEmployeeFormProps } from './types'

export const UserEditEmployeeForm = ({ user }: UserEditEmployeeFormProps): JSX.Element => {
  const { formId, loading, setTouched, setValid } = useContext(UserManagementFormContext)
  const { errors: apiErrors, updateEmployee } = useUpdateEmployee()

  return (
    <Form<EditSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={updateEmployee}
      onTouched={setTouched}
      onValid={setValid}
      schema={editSchema}
      schemaDefaults={editSchemaDefault(user)}
    >
      {() => <CommonForm variant='edit' />}
    </Form>
  )
}
